import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ParkingData } from '../../../../core/models/information.model';

@Component({
  selector: 'app-stamp-approve',
  imports: [
    CommonModule,
    FormsModule
  ],
  templateUrl: './stamp-approve.component.html',
  styleUrl: './stamp-approve.component.css'
})
export class StampApproveComponent {
  stamp_approve_list: any = [
    { id: 1, citizenName: 'John Doe', stampType: 'Type A', status: 'Pending', rate_id: 'R001' },
    { id: 2, citizenName: 'Jane Smith', stampType: 'Type B', status: 'Approved', rate_id: 'R002' },
    { id: 3, citizenName: 'Alice Johnson', stampType: 'Type C', status: 'Rejected', rate_id: 'R003' },
    { id: 4, citizenName: 'Bob Brown', stampType: 'Type A', status: 'Pending', rate_id: 'R004' },
    { id: 5, citizenName: 'Charlie Green', stampType: 'Type B', status: 'Approved', rate_id: 'R005' },
    { id: 6, citizenName: 'Diana White', stampType: 'Type C', status: 'Rejected', rate_id: 'R006' },
    { id: 7, citizenName: 'Eve Black', stampType: 'Type A', status: 'Pending', rate_id: 'R007' },
    { id: 8, citizenName: 'Frank Blue', stampType: 'Type B', status: 'Approved', rate_id: 'R008' },
    { id: 9, citizenName: 'Grace Red', stampType: 'Type C', status: 'Rejected', rate_id: 'R009' },
    { id: 10, citizenName: 'Henry Yellow', stampType: 'Type A', status: 'Pending', rate_id: 'R010' },
    { id: 11, citizenName: 'Ivy Purple', stampType: 'Type B', status: 'Approved', rate_id: 'R011' },
    { id: 12, citizenName: 'Jack Orange', stampType: 'Type C', status: 'Rejected', rate_id: 'R012' },
  ]
  searchQuery: string = '';

  stamp_approve_list_search: any = [];

  // Page
  currentPage: number = 1;
  itemsPerPage: number = 10;
  totalPages: number = 0;

  paginatedRequests: any[] = [];

  // Reject
  rejectReason: string = '';

  //Modal
  modalSelectRequest: boolean = false;
  modalSelectReject: boolean = false;

  //Selected
  isOpen = false;
  selectedStamp: any;

  // ข้อมูลรถ
  userName: string = '';

  //Discount
  discountAmountDemo: number | null = null;
  rate_rule: { [key: string]: number } = {
    '00006': 6,
    '00008': 8,
  };

  // API 
  ParkingData: ParkingData = {
    amount: 0,
    amounttopay: 0,
    cardcode: '',
    cardname: '',
    companyid: 0,
    encrypt: '',
    entry_date: '',
    entrydate: '',
    entrygate: '',
    exit_date: '',
    exitdate: '',
    hour: '',
    license: '',
    message: '',
    min: '',
    paid: 0,
    parkingtime: '',
    seq: '',
    siteid: 0,
    stamp: '',
    stampid: '',
    history_stamp: [],
    stamplist: [],
    status: false,
    vehicletypeid: '',
    vehicletypename: ''
  };
  demoImage: any | null = 'https://www.w3schools.com/howto/img_avatar.png';
  expandedImage: any | null = ''


  constructor() { }

  /* -------------------------------- ฟังก์ชั่น -----------------------------------------*/
  ngOnInit() {
    this.calculatePagination();
  }
  // ---------- Style ------------
  // ตัวเลือก Select
  selectStampOption(opt: any) {
    //เปลี่ยนค่า select
    this.selectedStamp = opt;
    this.isOpen = false;

    // สั่งทำงานคำนวณส่วนลด
    this.onDiscount()

  }
  selectImageExpanded() {
    this.expandedImage = this.demoImage;
  }
  // คำนวณหน้าเริ่มต้น
  calculatePagination() {
    if (this.stamp_approve_list_search.length > 0 || this.searchQuery !== '') {
      this.totalPages = Math.ceil(this.stamp_approve_list_search.length / this.itemsPerPage);
      this.updatePaginatedRequests();
    }
    else {
      this.totalPages = Math.ceil(this.stamp_approve_list.length / this.itemsPerPage);
      this.updatePaginatedRequests();
    }
  }
  // แบ่งหน้า
  updatePaginatedRequests() {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    if (this.stamp_approve_list_search.length > 0 || this.searchQuery !== '') {
      this.paginatedRequests = this.stamp_approve_list_search.slice(startIndex, endIndex);
    }
    else {
      this.paginatedRequests = this.stamp_approve_list.slice(startIndex, endIndex);
    }
    //console.log( "PaginatedRequests", this.paginatedRequests );
  }
  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePaginatedRequests();
    }
  }
  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePaginatedRequests();
    }
  }

  // ค้นหาข้อมูล
  filterRequests() {
    if (this.searchQuery !== '') {
      this.stamp_approve_list_search = this.stamp_approve_list.filter((item: any) =>
        item.citizenName.toLowerCase().includes(this.searchQuery.toLowerCase())
      );
      //console.log("Search", this.stamp_approve_list_search);
      return this.calculatePagination();
    }
    // reset ค่า
    this.stamp_approve_list_search = [];

    return this.calculatePagination();
  }
  // ---------- Function -----------
  checkApproveRequest(rate_id: string) {
    this.modalSelectRequest = false;
    //console.log(`Request with rate_id ${rate_id} approved.`);
  }
  checkRejectRequest(rate_id: string) {
    this.modalSelectReject = false;
    //console.log(`Request with rate_id ${rate_id} rejected.`);
  }



  // คำนวนค่าบริการ
  onDiscount() {
    const entryTime = new Date(this.ParkingData.entry_date);
    const exitTime = new Date(this.ParkingData.exit_date);
    const parkingTime = Math.abs(exitTime.getTime() - entryTime.getTime()) / (1000 * 60 * 60);
    //console.log('parkingTime', parkingTime );
    // เช็คค่าว่าง
    if (this.selectedStamp) {
      // เช็คว่ามีส่วนลดหรือไม่
      if (this.rate_rule[this.selectedStamp.rate_id]) {
        // คํานวณส่วนลด
        if (parkingTime <= this.rate_rule[this.selectedStamp.rate_id]) {
          this.discountAmountDemo = 0;
        }
      }
      else {
        this.discountAmountDemo = null
      }
    }
  }

  /* -------------------------------- API -----------------------------------------*/


}
